export default "__VITE_ASSET__8f95a510__"